import axios from 'axios';
import { logErrorToBackend } from './errorLogger';
import { API_URL } from '../config/config';

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
});

// Intercepteur pour ajouter le token JWT
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Intercepteur pour logger les erreurs API
api.interceptors.response.use(
    (response) => response,
    (error) => {
        // Logger uniquement les erreurs serveur (5xx) et les erreurs réseau critiques
        // Ne pas logger les 401, 403, 404 qui sont des erreurs "normales" du flux applicatif
        if (error.response) {
            const status = error.response.status;
            // Logger uniquement les erreurs serveur 5xx
            if (status >= 500) {
                logErrorToBackend(
                    new Error(`API Error ${status}: ${error.message}`),
                    {
                        type: 'api_response',
                        status: status,
                        statusText: error.response.statusText,
                        url: error.config?.url,
                        method: error.config?.method?.toUpperCase(),
                        data: error.response.data,
                        requestData: error.config?.data
                    }
                );
            }
        } else if (error.request) {
            // La requête a été faite mais pas de réponse reçue (timeout, network error, etc.)
            logErrorToBackend(
                new Error(`API Network Error: ${error.message}`),
                {
                    type: 'api_network',
                    url: error.config?.url,
                    method: error.config?.method?.toUpperCase(),
                    timeout: error.config?.timeout,
                    requestData: error.config?.data
                }
            );
        } else {
            // Erreur lors de la configuration de la requête
            logErrorToBackend(
                new Error(`API Setup Error: ${error.message}`),
                {
                    type: 'api_setup',
                    config: error.config
                }
            );
        }
        return Promise.reject(error);
    }
);

export const getProducts = () => api.get('/products');

// Export de l'instance axios configurée par défaut
export default api;
